import { CLICK_CODE } from '@local/utils'

import FlickingArea from '@web/components/FlickingArea/FlickingArea'
import { ListFilterWhiteButton } from '@web/ui/components/ListFilterButton'
import { BookingPrimitive } from '@web/ui/pages/home/components/Sections/UIDailyBriefingSection/DailyBriefingSection.type'

import styles from './DailyBriefingTab.module.scss'

interface Props {
  handleClickBooking: (bookingId: string) => void
  focusedBooking: BookingPrimitive
  todayBookings: BookingPrimitive[]
}

export default function DailyBriefingTab({ handleClickBooking, focusedBooking, todayBookings }: Props) {
  return (
    <div className={styles.tab_area}>
      <FlickingArea
        options={{
          align: 'prev',
        }}
      >
        {todayBookings.map(booking => {
          const isSelected = focusedBooking.id === booking.id
          const name = booking.placeSummary.name ? booking.placeSummary.name : booking.businessName

          return (
            <ListFilterWhiteButton
              key={booking.id}
              name={name}
              selected={isSelected}
              onClick={() => handleClickBooking(booking.id)}
              selectedBooking={booking}
              clickCode={CLICK_CODE['mydaily.otherplace']}
            />
          )
        })}
      </FlickingArea>
    </div>
  )
}
